import http from './http';

export default {

	WMS_URL: http.baseURL() + '/camadas/wms',

	MAIS_INFORMACOES_URL: http.baseURL() + '/camadas/{idCamada}/maisInformacoes?id={idRegistro}',
	
	findAll (callback) {

		return http.get({
			url: '/camadas',
			success: callback
		});
	},

	findInformacoes (idsCamadas, wktPonto, callback, errorCallback, options) {

		return http.post({
			url: '/camadas/informacoes/wkt',
			success: callback,
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: wktPonto,
				idsCamadas: idsCamadas
			}
		});
	},

	findGrupoInformacoesByWKT (params, callback, errorCallback, options) {

		return http.post({
			url: '/camadas/grupoInformacoes/wkt',
			success: (data, response) => processarHeadersWkt(response, callback),
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: params.wkt,
				wktKey: params.wktKey,
				idsCamadas: params.idsCamadas
			}
		});
	},

	findInformacoesByWKT (params, callback, errorCallback, options) {

		return http.post({
			url: '/camadas/informacoes/wkt',
			success: (data, response) => processarHeadersWkt(response, callback),
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: params.wkt,
				wktKey: params.wktKey,
				idsCamadas: params.idsCamadas,
				pagina: params.pagina
			}
		});
	},

	exportCSVInformacoesCamadaByWKT (params, callback, errorCallback, options) {

		return http.post({
			url: '/camadas/informacoes/csv',
			success: (data, response) => processarHeadersWkt(response, callback),
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: params.wkt,
				wktKey: params.wktKey,
				idsCamadas: params.idsCamadas
			}
		});
	},

	findMarcadores (idsCamadas, wktBBox, callback) {

		return http.get({
			url: '/camadas/marcadores',
			success: callback,
			lockScreen: false,
			data: {
				bbox: wktBBox,
				camadas: idsCamadas && idsCamadas.join(',')
			}
		});
	},

	findRegistroById (idCamada, idRegistro, callback, errorCallback, options) {

		return http.get({
			url: '/camadas/' + idCamada + '/registros/' + idRegistro,
			success: callback,
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage
		});
	},
	
	findAtributos (idCamada, options, callback) {

		return http.get({
			url: '/camadas/' + idCamada + '/atributos',
			success: callback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage
		});
	},

	pesquisar (params, options, callback) {
		return http.get({
			url: '/camadas/pesquisa',
			success: callback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: params

		});
	}
};

const WKT_EXPIRATION_MARGIN = 2 * 60000; // 2 minutos

function processarHeadersWkt (response, callback) {
	
	let data = {
		data: response.data
	};

	let headers = response && response.headers;

	if (headers) {

		let wktKey = headers['wkt-key'];
		let wxtExpirationSec = headers['wkt-expiration-time-sec'];

		if (wktKey && wxtExpirationSec) {

			data.wktKey = wktKey;
			data.wktExpiration = new Date();
			data.wktExpiration.setTime(data.wktExpiration.getTime() + (wxtExpirationSec * 1000) - WKT_EXPIRATION_MARGIN);
		}
	}

	if (callback) callback(data);
};



// WEBPACK FOOTER //
// ./src/services/camadasService.js